import { Trans } from "react-i18next";

import { Link } from "./components";

const News3 = () => {
    return (
        <Trans
            i18nKey={"Dashboard##news##body##3"}
            components={{
                section: <section />,
                p: <p />,
                ul: <ul />,
                li: <li />,
                strong: <strong />,
                a: (
                    <Link href="https://wiki.teltonika-gps.com/view/FOTA_WEB_Devices#Unlock_FT/FMx_device">
                        ""
                    </Link>
                )
            }}
        />
    );
};

export { News3 };
